var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBeamRifle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 60,
    viewBox: "0 0 120 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M117.089 39.1966C117.026 38.3836 116.477 37.6861 115.391 36.8191C114.305 35.9506 113.047 36.4756 111.781 36.5971C110.515 36.7186 109.312 36.7186 109.312 36.7186C109.312 36.7186 105.086 35.4016 103.901 34.3936C102.716 33.3856 103.036 32.8366 102.974 32.1121C102.913 31.3876 103.496 31.1461 104.192 30.8821C104.89 30.6181 104.896 30.4261 104.803 29.0461C104.71 27.6661 103.261 26.5171 103.066 26.0776C102.871 25.6381 103.235 25.6531 104.192 25.2736C105.149 24.8941 107.117 25.2736 107.117 25.2736L109.879 23.4571C109.879 23.4571 111.704 20.4751 111.773 20.0146C111.842 19.5541 111.353 18.8311 110.585 18.2656C109.817 17.7001 108.079 18.3421 108.079 18.3421C108.079 18.3421 103.406 18.3466 100.213 18.2506C97.0194 18.1561 94.3209 16.8226 94.3209 16.8226L92.4924 15.1576H90.7869L85.6689 14.3041L83.7999 14.3881C83.7999 14.3881 73.0749 12.9766 70.6929 13.2856C68.3109 13.5946 65.5359 15.0796 65.5359 15.0796C65.5359 15.0796 63.2019 15.5746 62.4054 16.0636C61.6089 16.5526 60.7104 17.5891 60.7104 17.5891C60.7104 17.5891 59.2089 18.4111 57.4764 18.8266C55.7424 19.2436 52.2804 19.3756 52.2804 19.3756L40.8444 19.8691L24.7329 20.3971L17.6619 20.9731C17.6619 20.9731 9.72988 21.8011 7.58938 22.4836C5.44738 23.1661 5.18638 23.4796 4.80688 23.7721C4.42738 24.0661 3.16138 26.0776 3.16138 26.0776L5.69338 26.2486L6.52588 26.7946L6.74938 27.7501L7.10188 28.5436L4.88038 28.9561L3.86188 29.6056C3.86188 29.6056 4.44688 30.3076 5.47588 30.4426C6.50488 30.5776 6.74938 31.6081 6.74938 31.6081C6.74938 31.6081 6.45088 32.5321 5.90638 33.1351C5.36038 33.7381 3.25888 34.0726 3.25888 34.0726C3.25888 34.0726 3.79138 34.9201 4.38238 35.5246C4.97338 36.1291 6.23788 36.7576 7.58938 37.0846C8.94088 37.4131 13.0614 37.2106 13.0614 37.2106L21.0234 37.4071C21.0234 37.4071 21.9984 37.5691 23.9964 37.1926C25.9944 36.8161 33.2649 37.1356 41.7159 36.9376C50.1669 36.7396 61.4919 39.0586 62.4054 39.3031C63.3189 39.5476 65.3169 40.0576 65.3169 40.0576L77.5449 40.0066L86.6724 41.6236C86.6724 41.6236 86.8869 40.8196 86.9424 40.5556C86.9964 40.2916 87.6729 40.1161 87.8364 40.1701C87.9999 40.2241 88.9464 39.8986 89.4609 40.1701C89.9754 40.4416 90.3819 40.1701 90.6759 40.4416C90.9699 40.7131 92.0199 40.4416 92.0199 40.4416C92.0199 40.4416 93.1704 40.6576 93.4689 40.8211C93.7674 40.9831 94.5504 40.6501 94.6944 40.7596C94.8369 40.8691 96.3669 42.3151 96.3669 42.3151C96.3669 42.3151 96.8319 42.2866 97.4649 42.0196C98.0964 41.7526 102.056 41.6236 106.822 41.4241C111.587 41.2246 115.706 41.3551 116.563 41.3341C117.419 41.3131 117.152 40.0126 117.091 39.1996L117.089 39.1966ZM58.6674 29.9146L57.9084 29.2261H56.8794L56.1759 29.9146L55.4169 29.3881L54.2259 29.3341L53.5764 29.9146L52.8729 29.3341L51.6819 29.2801L50.8689 29.9146L50.1099 29.2801L48.8634 29.3341L48.2139 29.9146L47.2929 29.2261L45.9924 29.1721L45.5049 29.9146H44.1504L43.4469 29.4961L23.8389 29.6041L22.8339 28.9171L21.7809 28.1956L23.8389 29.6041L24.9759 28.7911L43.6629 28.7371L44.3124 28.1956H45.7209L46.6959 27.7966L47.5089 28.2616H48.6459L49.1334 27.7471H49.8369L50.2704 28.2616H51.1914L51.7329 27.7471H52.4364L52.8699 28.2616H53.9529L54.6024 27.3721H55.2519L55.9554 28.2616H57.1464L57.5799 27.3721L58.6629 27.1801V29.9146H58.6674ZM95.4324 25.6441C96.0939 25.6441 96.6309 26.1811 96.6309 26.8426C96.6309 27.5041 96.0939 28.0411 95.4324 28.0411C94.7709 28.0411 94.2339 27.5041 94.2339 26.8426C94.2339 26.1811 94.7709 25.6441 95.4324 25.6441ZM100.643 27.7981C100.319 28.4671 99.4539 29.0086 99.4539 29.0086C99.4539 29.0086 100.228 29.5441 100.436 30.4411C100.645 31.3381 100.603 32.0131 99.9474 32.3791C99.2919 32.7451 98.4789 33.1516 97.7754 32.4616C97.0719 31.7716 96.7989 30.7426 96.1224 31.2841C95.4459 31.8256 95.3994 31.6636 94.4739 31.8256C93.5499 31.9876 91.9254 32.0971 91.9254 32.0971L91.0854 31.8256C91.0854 31.8256 93.0744 29.1316 92.6619 28.0411L94.4739 29.3641H96.7989C96.7989 29.3641 97.7844 28.6546 97.8609 27.7756C97.9374 26.8966 99.3024 25.6801 99.9474 26.1256C100.592 26.5711 100.967 27.1276 100.645 27.7981H100.643Z",
    fill: "#FAFAFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2727 35.292L38.7352 34.3935H57.2047L63.3262 33.1335L68.4712 34.6425L71.3452 38.4465L76.3792 39.951",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2053 34.3935L58.3978 35.7",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M72.6432 23.772L70.3137 22.908L71.3892 20.652L72.1557 19.0425",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4972 17.256L79.3602 18.177L71.3892 20.652",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M91.4368 24.081L92.3218 23.16V21.9135L91.7323 19.8015H95.4328C95.4328 19.8015 97.4503 19.422 98.1538 20.9925C98.8573 22.563 98.9668 23.4945 98.9668 23.4945H106.549L106.875 22.104L109.15 21.264L110.587 22.482",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8391 33.4861L93.1436 34.6966H98.6156L100.809 35.1841L101.377 35.7001L107.254 37.0801L109.881 36.7306",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M91.8147 26.448L94.3227 24.8655H96.7197L97.7352 25.656L99.7662 24.8655H102.142L102.813 24.2775H106.632L108.081 24.81",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.15356 33.6135C5.15356 33.6135 5.47906 35.112 7.59106 35.0475",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.34856 23.7195C8.34856 23.7195 5.31556 24.6495 5.15356 25.962",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M60.4211 26.793L65.3171 27.9045V28.812L62.2301 29.6355L62.1476 30.7665",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8225 27.9436V29.1106L61 29.2426L63.5395 28.4611L60.9505 27.8416L59.8225 27.9436Z",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M81.4045 21.2641L81.505 20.0521L82.5415 19.7611L83.74 20.5591L84.7345 19.4626L86.128 19.5856L86.71 21.0196L88.0255 20.0926L89.203 20.6941L88.8955 22.1041",
    stroke: "#B5B5BE",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M3.16235 26.0776C3.16235 26.0776 4.01585 22.4926 10.1089 21.7501C16.2019 21.0076 24.7339 20.3986 24.7339 20.3986C24.7339 20.3986 48.4984 19.6681 51.6679 19.4236C54.8359 19.1806 57.9634 19.0576 60.4219 17.9611C60.4219 17.9611 61.7824 16.1326 62.6359 15.7681C63.4894 15.4036 65.8039 15.0376 65.8039 15.0376C65.8039 15.0376 68.9719 12.9661 73.8469 13.3321C78.7219 13.6981 84.0843 14.4286 84.0843 14.4286L85.6683 14.3071L90.7863 15.1606H92.4918L94.3203 16.8256C94.3203 16.8256 96.7578 17.9626 99.5613 18.2071C102.365 18.4501 109.19 18.3286 109.19 18.3286C109.19 18.3286 110.652 17.9626 111.14 18.5716C111.627 19.1806 111.87 19.3021 111.749 20.2771C111.627 21.2521 109.677 23.7211 109.677 23.7211C109.677 23.7211 107.972 25.0291 107.118 25.2736C106.265 25.5166 105.047 25.1521 104.193 25.2736C103.34 25.3951 102.488 25.8826 103.584 26.8576C104.681 27.8326 104.802 28.8316 104.925 29.9161C105.047 31.0006 104.195 30.8821 104.195 30.8821C104.195 30.8821 102.977 31.0306 102.977 32.1121C102.977 33.1936 103.343 34.0231 104.073 34.5226C104.804 35.0221 108.948 36.5971 108.948 36.5971C108.948 36.5971 110.472 36.9526 111.782 36.5971C113.091 36.2416 114.879 36.7546 114.879 36.7546C114.879 36.7546 115.895 36.6586 116.504 37.7296C117.113 38.8006 117.234 39.5311 117.113 40.5061C116.991 41.4811 116.259 41.3641 116.259 41.3641C116.259 41.3641 111.629 41.2561 108.338 41.3686C105.047 41.4811 97.8573 41.7256 97.2468 42.0916C96.6363 42.4576 96.2718 42.4651 95.2968 41.3641C94.3218 40.2631 94.2543 40.6021 94.2543 40.6021C94.2543 40.6021 94.1733 40.9276 93.4683 40.8181C92.7648 40.7101 92.4123 40.4386 92.4123 40.4386C92.4123 40.4386 92.2773 40.7911 91.4103 40.5466C90.5433 40.3036 90.3813 40.1671 90.3813 40.1671C90.3813 40.1671 89.9748 40.4386 89.4603 40.1671L88.9458 39.8956C88.9458 39.8956 88.0788 40.2751 87.6723 40.1116L87.2658 39.9496L87.0228 41.6836L77.5444 40.0051L64.5859 40.0591C64.5859 40.0591 59.9149 37.7296 45.6694 37.0801C31.4239 36.4306 21.0244 37.4056 21.0244 37.4056L10.0294 37.1341C10.0294 37.1341 7.26635 37.3501 6.02135 36.6466C4.77485 35.9431 3.61085 35.0761 3.16385 33.8296C3.16385 33.8296 4.50485 33.9916 5.15435 33.6136C5.80385 33.2356 6.45485 32.7466 6.45485 32.7466V31.6636C6.45485 31.6636 7.80935 31.4476 7.75535 31.1221C7.70135 30.7966 5.10185 30.5266 4.72235 30.4186C4.34285 30.3106 3.69335 29.8771 3.90935 29.4436C4.12535 29.0101 4.88435 28.9561 4.88435 28.9561C4.88435 28.9561 7.97135 28.6846 7.91735 28.3066C7.86335 27.9286 6.88835 27.7996 6.88835 27.7996L6.78035 27.0601L5.91335 26.1391L3.16385 26.0776H3.16235Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5329 29.538L22.1324 31.8945C22.1324 31.8945 22.5794 32.625 21.7259 33.0315C20.8724 33.438 19.2479 32.544 18.5159 31.935C17.7839 31.326 16.2809 30.3915 16.4849 29.538C16.6889 28.6845 17.9204 27.96 18.6374 27.7995C19.5719 27.588 20.4254 28.035 19.5314 29.538H19.5329Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7507 29.538L16.3502 31.8945C16.3502 31.8945 16.7972 32.625 15.9437 33.0315C15.0902 33.438 13.4657 32.544 12.7337 31.935C12.0032 31.326 10.4987 30.3915 10.7027 29.538C10.9067 28.6845 12.1382 27.96 12.8552 27.7995C13.7897 27.588 14.6432 28.035 13.7492 29.538H13.7507Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6917 30.3075C16.6917 30.3075 16.1592 31.038 15.2052 30.8565C14.2512 30.675 13.7502 29.538 13.7502 29.538C13.7502 29.538 14.6952 28.533 13.9662 28.0005L16.9737 25.923C16.9737 25.923 18.9402 25.1505 19.3587 26.166C19.7772 27.1815 18.6387 27.798 18.6387 27.798C18.6387 27.798 15.7602 28.9245 16.6917 30.3075Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7767 30.3075C10.7767 30.3075 10.2442 31.038 9.29021 30.8565C8.33621 30.675 7.83521 29.538 7.83521 29.538C7.83521 29.538 8.7802 28.533 8.0512 28.0005L11.0587 25.923C11.0587 25.923 13.0252 25.1505 13.4437 26.166C13.8622 27.1815 12.7237 27.798 12.7237 27.798C12.7237 27.798 9.8452 28.9245 10.7767 30.3075Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4504 27.1815L48.5384 26.7885L51.6254 24.5685H56.5004L62.8919 26.247L58.6664 27.1815V29.9145L62.4044 30.885L57.4214 31.8255L49.4054 30.885H22.5929L21.6524 31.458",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5305 30.441L21.7815 28.197L23.8395 29.6055L24.9765 28.7925L43.6635 28.7385L44.313 28.197H45.7215L46.6965 27.798L47.5095 28.263H48.6465L49.134 27.75H49.8375L50.271 28.263H51.192L51.7335 27.75H52.4385L52.872 28.263H53.955L54.6045 27.3735H55.254L55.959 28.263H57.15L57.5835 27.3735L58.6665 27.1815V29.9145L57.909 29.226H56.88L56.175 29.9145L55.4175 29.388L54.225 29.334L53.5755 29.9145L52.872 29.334L51.6795 29.28L50.868 29.9145L50.109 29.28L48.864 29.334L48.213 29.9145L47.292 29.226L45.993 29.172L45.5055 29.9145H44.151L43.4475 29.4975L23.8395 29.6055",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7341 20.3971C24.7341 20.3971 23.8941 22.1851 25.1406 22.4551C26.3871 22.7266 43.6656 22.6711 43.6656 22.6711L51.6276 24.5671",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M56.5002 24.5686L57.6372 23.4841L65.9247 20.9386L66.9537 19.0426L62.8917 18.1231L60.4197 17.9596",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9543 19.0425L69.9873 19.8015L72.1533 19.0425L72.6948 17.634L76.9203 16.551L80.4948 17.2545C80.4948 17.2545 86.5068 15.63 90.7323 18.609L94.3203 16.821",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3203 27.798L94.3213 29.226H96.5278C96.5278 29.226 97.3408 29.064 97.7188 28.197C98.0968 27.33 97.7728 26.6265 98.9098 26.193C100.047 25.7595 100.806 26.5455 100.806 27.1815C100.806 27.8175 100.156 28.668 99.5053 28.812L99.4513 29.4975C99.4513 29.4975 101.13 30.2565 100.372 31.827C99.6148 33.3975 97.6648 32.3685 97.3933 31.827L97.1218 31.2855L95.9848 31.1775L95.4973 31.827H92.6263C92.6263 31.827 92.4643 32.3685 91.9228 32.0985C91.3813 31.827 91.4353 31.3395 91.4353 31.3395C91.4353 31.3395 92.3773 29.916 92.3188 27.7995L92.3203 27.798Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M95.4315 27.9525C96.0446 27.9525 96.5415 27.4556 96.5415 26.8425C96.5415 26.2295 96.0446 25.7325 95.4315 25.7325C94.8185 25.7325 94.3215 26.2295 94.3215 26.8425C94.3215 27.4556 94.8185 27.9525 95.4315 27.9525Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4984 39.7064L87.5774 37.4999L87.7814 36.4844L88.7144 35.9564",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M90.3813 40.167L89.4573 37.866L89.8533 36.5865L90.6753 36.048",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4127 40.4384C92.4127 40.4384 92.1082 39.0134 91.7317 38.2319L92.0722 36.8819L92.9107 36.4559",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3432 40.5539C94.3432 40.5539 94.1197 38.9729 93.8752 38.5364C93.8752 38.5364 94.1092 37.2764 94.1902 37.2359C94.2712 37.1954 95.0737 36.7184 95.0737 36.7184",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4885 26.5561C79.889 25.3261 80.5295 24.4201 81.623 23.7721",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M82.0626 32.8814C80.6436 32.1359 79.6521 30.9929 79.3596 29.3639",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M88.0244 32.1525C87.0674 33.105 85.9724 33.4845 84.5159 33.4845",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M89.5083 26.448C89.7003 26.9955 89.8053 27.585 89.8053 28.197C89.8053 28.695 89.7363 29.178 89.6073 29.6355",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4192 22.9095C84.4522 22.9095 84.4837 22.9095 84.5167 22.9095C85.8427 22.9095 86.9062 23.2755 87.8347 24.081",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5159 35.7C88.6597 35.7 92.0189 32.3408 92.0189 28.197C92.0189 24.0532 88.6597 20.694 84.5159 20.694C80.3722 20.694 77.0129 24.0532 77.0129 28.197C77.0129 32.3408 80.3722 35.7 84.5159 35.7Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8918 26.247L80.6383 21.9135",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4045 30.8849L80.286 34.3934",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1497 35.7L84.2867 38.6355L87.2657 39.951",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M83.1503 24.8654L84.5168 24.5684V22.9079L83.4353 22.1039L81.8093 22.4819L81.6233 23.7719L83.1503 24.8654Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M87.2659 25.434L88.1464 26.6535L89.5309 26.517L90.0664 25.434L88.9999 24.081H87.8359L87.2659 25.434Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4714 29.5785L87.5774 30.6345L88.0244 32.1525L89.2019 32.463L90.0659 31.203L89.8049 29.5785H88.4714Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5972 34.3936L84.5167 33.4861L84.7342 31.8256L83.5972 31.2841L81.9817 32.8396V33.9661L83.5972 34.3936Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M71.0852 28.812L78.1127 30.441L79.3592 29.364L81.2807 28.812V27.3735L79.4582 26.6535L77.5667 25.3665L71.0852 27.3735V28.812Z",
    stroke: "#FAFAFB",
    strokeWidth: 1.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeamRifle);
export default __webpack_public_path__ + "static/media/Beam Rifle.8c485942a5a05f7dd33bbc33177160bf.svg";
export { ForwardRef as ReactComponent };